import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportGroupActiveSessionsLazy
} from "@containers/reports/readyReports/reportGroupActiveSessions/ReportGroupActiveSessions.lazy";

const ReportGroupActiveSessionsPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportGroupActiveSessionsLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportGroupActiveSessionsPage;